import type { MouseEvent, ReactElement, ReactNode, Ref, RefObject } from 'react';
import { motion } from 'framer-motion';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { STRETCH_MODAL_MOTION_PROPS, STRETCH_OVERLAY_MOTION_PROPS, } from './Cstretchmodal.constants';
import type { CstretchmodalStyleModel } from './Cstretchmodal.types';
import { CstretchmodalSurface } from './CstretchmodalSurface';
interface CstretchmodalOverlayProps {
    bodyRef?: Ref<HTMLDivElement>;
    canClose: boolean;
    children?: ReactNode;
    className?: string;
    dataElScope: DataElScope;
    floatingFooter: boolean;
    footer?: ReactNode;
    handleClose: () => void;
    header?: ReactNode;
    overlayPortalTargetId?: string;
    showBackButton: boolean;
    stopPropagation: (event?: MouseEvent) => void;
    styleModel: CstretchmodalStyleModel;
    surfaceRef: RefObject<HTMLDivElement | null>;
}
export function CstretchmodalOverlay({ bodyRef, canClose, children, className, dataElScope, floatingFooter, footer, handleClose, header, overlayPortalTargetId, showBackButton, stopPropagation, styleModel, surfaceRef, }: CstretchmodalOverlayProps): ReactElement {
    return (
      <motion.div data-el={dataEl(dataElScope, 'Overlay/Backdrop')} style={styleModel.overlayStyle} initial={STRETCH_OVERLAY_MOTION_PROPS.initial} animate={STRETCH_OVERLAY_MOTION_PROPS.animate} exit={STRETCH_OVERLAY_MOTION_PROPS.exit} onClick={handleClose}>
        <div data-el={dataEl(dataElScope, 'Overlay/Frame')} style={styleModel.containerStyle}>
          <motion.div data-el={dataEl(dataElScope, 'Overlay/Panel')} style={styleModel.modalStyle} initial={STRETCH_MODAL_MOTION_PROPS.initial} animate={STRETCH_MODAL_MOTION_PROPS.animate} exit={STRETCH_MODAL_MOTION_PROPS.exit}>
            <CstretchmodalSurface bodyRef={bodyRef} canClose={canClose} className={className} dataElScope={dataElScope} floatingFooter={floatingFooter} footer={footer} handleClose={handleClose} header={header} overlayPortalTargetId={overlayPortalTargetId} showBackButton={showBackButton} stopPropagation={stopPropagation} styleModel={styleModel} surfaceRef={surfaceRef}>
              {children}
            </CstretchmodalSurface>
          </motion.div>
        </div>
      </motion.div>
    );
}
